import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../auth/supabase';
import styles from './SignIn.module.css';

export default function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mode, setMode] = useState('signin'); // 'signin' | 'signup'
  const [fullName, setFullName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      if (mode === 'signin') {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
      } else {
        const { data, error } = await supabase.auth.signUp({
          email,
          password,
          options: { data: { full_name: fullName, name: fullName } },
        });
        if (error) throw error;
        // If email confirmations are disabled, session may be created immediately.
        // Otherwise, sign in after sign up (for local dev with auto-confirm, this is instant).
        if (!data.session) {
          const res = await supabase.auth.signInWithPassword({ email, password });
          if (res.error) throw res.error;
        }
      }
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  const title = mode === 'signin' ? 'Sign In' : 'Sign Up';
  const buttonLabel = title;

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h2 className={styles.title}>{title}</h2>
        <form onSubmit={onSubmit} className={styles.form}>
          <label className={styles.label}>
            <span>Email</span>
            <input className={styles.input} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          <label className={styles.label}>
            <span>Password</span>
            <input className={styles.input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </label>
          {mode === 'signup' && (
            <label className={styles.label}>
              <span>Full name</span>
              <input className={styles.input} type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} required />
            </label>
          )}
          {error && <div className={styles.error}>{error}</div>}
          <button className={styles.button} disabled={loading} type="submit">{buttonLabel}</button>
        </form>
        <div className={styles.switch}>
          {mode === 'signin' ? (
            <span>
              New here? <button className={styles.link} onClick={() => setMode('signup')} type="button">Create an account</button>
            </span>
          ) : (
            <span>
              Already have an account? <button className={styles.link} onClick={() => setMode('signin')} type="button">Sign in</button>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
